import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from '../shared/servicebase'
import { Helper } from '../shared/Helper';

@Injectable({
  providedIn: 'root'
})
export class CacheService extends ServiceBase {

  public Cache: any;

  constructor(http: HttpClient) {
    super(http);

  }

  public GetDataCache(){        
    return this.GetValue<any>('cache/getdatacache/' + Helper.getUserIdToken());
  }

  public GetCache(){        
    return this.GetValue<any>('cache/getcache/' + Helper.getUserIdToken());
  }

  public IncluirCache(): any{        
    var obj = {
      usuarioId: Helper.getUserIdToken(),
    };
    return this.SetValue('cache/incluircache',obj);
  }

  public AddItemCache(PedidoCacheId: string, ProdutoId: string, quantidade: number): any{        
    var obj = {
      quantidade: quantidade,
      ProdutoId: ProdutoId,
      PedidoCacheId: PedidoCacheId
    };
    return this.SetValue('cache/additemcache',obj);
  }

  public UpdateItemCache(PedidoCacheId: string, ProdutoId: string, quantidade: number): any{        
    var obj = {      
      quantidade: quantidade,
      ProdutoId: ProdutoId,
      PedidoCacheId: PedidoCacheId
    };
    return this.SetValue('cache/updateitemcache',obj);
  }

  public RemoveItemCache(PedidoCacheId: string, ProdutoId: string): any{        
    var obj = {            
      ProdutoId: ProdutoId,
      PedidoCacheId: PedidoCacheId
    };
    return this.SetValue('cache/removeitemcache',obj);
  }

  public FinalizarCache(): any{        
    var obj = {
      usuarioId: Helper.getUserIdToken(),
    };
    return this.SetValue('cache/incluircache',obj);
  }

  

  

  


}
